import { render, staticRenderFns } from "./RestaurantMealsStats.vue?vue&type=template&id=9a1c0750&scoped=true"
import script from "./RestaurantMealsStats.vue?vue&type=script&lang=js"
export * from "./RestaurantMealsStats.vue?vue&type=script&lang=js"
import style0 from "./RestaurantMealsStats.vue?vue&type=style&index=0&id=9a1c0750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1c0750",
  null
  
)

export default component.exports